import { useInsertionEffect, useRef } from "react";

/**
 * Creates MutableRefObject for the given value. The current
 * property of the returned reference is updated to the value
 * on every render.
 */
export const useValueRef = <T>(value: T) => {
  const ref = useRef<T>(value);

  useInsertionEffect(() => {
    ref.current = value;
  });

  return ref;
};
